
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as _ref_QGpzLWpvZGEvY29yZQ_ from '@js-joda/core';
import { instantiate } from './web-blog-cmp-components.uninstantiated.mjs';


const exports = (await instantiate({
    './skiko.mjs': Li9za2lrby5tanM,
    '@js-joda/core': _ref_QGpzLWpvZGEvY29yZQ_
})).exports;

export const {
initComponents,
clearComponent,
clearAllComponents,
reloadComponents,
renderLifeCalendar,
renderResizeStateProbe,
renderMoodBoardWidget,
renderPulsePollWidget,
renderReadingRhythmWidget,
renderIdeaRouletteWidget,
renderTinyBudgetWidget,
memory,
_initialize
} = exports


